class ExerciseService {
    constructor($http, authenticationService, globalConstants) {
        this.$http = $http;
        this.token = authenticationService.getToken();
        this.$http.defaults.headers.common.Authorization = 'Bearer ' + this.token;
        this.globalConstants = globalConstants;
    }

    getAll(query) {        
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/exercises/getbyevent',
            params: query
        });
    }

    getByEventId(query) {        
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/exercises/getbyeventid',
            params: query
        });
    }

    get(id) {        
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/exercises/' + id
        });
    }

    add(exercise) {        
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/exercises',
            data: exercise
        });
    }

    startExercise(id) {        
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/exercises/startexercise?exerciseId='+id,
        });
    }

    endExercise(id) {        
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/exercises/endexercise?exerciseId='+id,
        });
    }

    delete(eventId, exerciseId) {
        return this.$http({
            method: 'DELETE',
            url: this.globalConstants.ApiBaseUrl + '/api/exercises/' + eventId + '/' + exerciseId,
        });
    }

    insertExercise(exercise) {        
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/exercises/insertexercise',
            data: exercise
        });
    }

    updateExercise(exercise) {        
        return this.$http({
            method: 'PUT',
            url: this.globalConstants.ApiBaseUrl + '/api/exercises/updateexercise',
            data: exercise
        });
    }

    getExerciseSessionData(exerciseId) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/exercises/' + exerciseId + '/GetExerciseSessionData'
        });
    }

    duplicateExercise(exerciseId) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/exercises/duplicateexercise?exerciseId='+exerciseId,
        });
    }

    saveOrder(payload) {
        return this.$http({
            method: 'PUT',
            url: this.globalConstants.ApiBaseUrl + '/api/exercises/save-order',
            data: payload
        });
    }
}

export default ExerciseService;


// WEBPACK FOOTER //
// ./src/js/services/exercise.service.js